import React from 'react';
import { Box, Typography } from '@mui/material';
import { createStyleSheet } from 'utils/helpers';
import PaymentConstants from '../constants';
import StatusDotGreenIcon from 'pages/admin/campaign/components/icons/status-dot-green-icon';
import StatusDotRedIcon from 'pages/admin/campaign/components/icons/status-dot-red-icon';

const decideComponentStatusDot = (status: string) => {
    switch (status) {
        case PaymentConstants.status.PAID:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotGreenIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Đã thanh toán
                    </Typography>
                </Box>
            );
        case PaymentConstants.status.PENDING:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotRedIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Chưa thanh toán
                    </Typography>
                </Box>
            );
        case PaymentConstants.status.EXPIRED:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotRedIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Đã hết hạn
                    </Typography>
                </Box>
            );
        case PaymentConstants.status.FAILED:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotRedIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Thanh toán thất bại
                    </Typography>
                </Box>
            );
        default:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotRedIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Không xác định
                    </Typography>
                </Box>
            );
    }
};

const PaymentStatus: React.FC<{ status: string }> = ({ status }) => {
    return <>{decideComponentStatusDot(status)}</>;
};
const styles = createStyleSheet({
    boxStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    textStatus: {
        fontSize: '14px',
        lineHeight: '17px',
    },
});
export default PaymentStatus;
